import { useState } from "react";

interface PasswordState {
  password: string;
  confirm: string;
}

export const usePasswordValidation = (
  handleUser: (
    password: string,
    token: string,
    userId: string
  ) => Promise<boolean>
) => {
  const [password, setPassword] = useState<PasswordState>({
    password: "",
    confirm: "",
  });
  const [touched, setTouched] = useState({ password: false, confirm: false });
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleNewPasswordChange = (value: string) => {
    setPassword((prev) => ({ ...prev, password: value }));
  };

  const handleConfirmPasswordChange = (value: string) => {
    setPassword((prev) => ({ ...prev, confirm: value }));
  };

  const handleBlur = (field: "password" | "confirm") => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  const getPasswordError = () => {
    if (!touched.password) return "";
    if (password.password === "") return "";
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?]).{8,}$/;
    if (!passwordRegex.test(password.password)) {
      return "Пароль должен содержать минимум 8 символов, включая прописные буквы, цифры и специальные символы";
    }
    return "";
  };

  const getConfirmError = () => {
    if (!touched.confirm) return "";
    if (password.confirm === "") return "";
    if (password.password !== password.confirm) return "Пароли не совпадают";
    return "";
  };

  const handleSubmit = async (token: string, userId: string) => {
    setTouched({ password: true, confirm: true });
    const passwordError = getPasswordError();
    const confirmError = getConfirmError();
    if (passwordError || confirmError) return false;

    setLoading(true);
    const success = await handleUser(password.password, token, userId);
    if (success) setIsSuccess(true);
    setLoading(false);
    return success;
  };

  return {
    password,
    touched,
    loading,
    isSuccess,
    handleNewPasswordChange,
    handleConfirmPasswordChange,
    handleBlur,
    getPasswordError,
    getConfirmError,
    handleSubmit,
  };
};
